export const SHOW_LOADER = '[App] SHOW LOADER';
export const HIDE_LOADER = '[App] HIDE LOADER';

export const SHOW_TOAST = '[App] SHOW TOAST';
export const HIDE_TOAST = '[App] HIDE TOAST';

export const SHOW_API_ERROR = '[App] SHOW API ERROR';
export const HIDE_API_ERROR = '[App] HIDE API ERROR';
